import { formatTitle } from '@/utils/common'
export default {
  data() {
    return {
      newUkeyCol: [ // Ukey审核表头
        { field: 'operation', title: '操作', width: 120, isResize: true, titleAlign: 'left', columnAlign: 'left', componentName: 'operateVerify' },
        { field: 'cay_comfirm_state2', title: '状态', width: 60, isResize: true, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '0') {
              return `<span class='cell-edit-color'>待审核</span>`
            } else if (rowData[field] === '4') {
              return `<span class='cell-edit-color'>待审核</span>`
            } else if (rowData[field] === '7') {
              return `<span class='cell-edit-color'>待审核</span>`
            }
          } },
        { field: 'cay_no', title: '企业编码', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_type', title: '企业类型', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '0') {
              return `<span class='cell-edit-color'>商业公司</span>`
            } else if (rowData[field] === '1') {
              return `<span class='cell-edit-color'>服务商</span>`
            } else if (rowData[field] === '2') {
              return `<span class='cell-edit-color'>药品生产企业</span>`
            }
          } },
        { field: 'cay_nature', title: '企业性质', width: 130, isResize: true, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '0') {
              return `<span class='cell-edit-color'>企业</span>`
            } else if (rowData[field] === '1') {
              return `<span class='cell-edit-color'>个体工商户</span>`
            } else if (rowData[field] === '2') {
              return `<span class='cell-edit-color'>政府机关/事业单位</span>`
            }
          } },
        { field: 't_agent_info_agent_name', title: '渠道', width: 95, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'cay_name', title: '企业名称', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'certificateUrl', title: '天威授权书', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left', componentName: 'certificateUrl' },
        { field: 'signatureUrl', title: '签章', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left', componentName: 'signatureUrl' },
        { field: 'cay_receive_name', title: '收件人姓名', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_receive_address', title: '收件人地址', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_receive_tel', title: '联系电话', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' }
      ],
      ruanZhengShuCol: [ // 软证书审核表头
        { field: 'operation', title: '操作', width: 120, isResize: true, titleAlign: 'left', columnAlign: 'left', componentName: 'operateVerify' },
        { field: 'cay_comfirm_state2', title: '状态', width: 60, isResize: true, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '0') {
              return `<span class='cell-edit-color'>待审核</span>`
            } else if (rowData[field] === '4') {
              return `<span class='cell-edit-color'>待审核</span>`
            } else if (rowData[field] === '7') {
              return `<span class='cell-edit-color'>待审核</span>`
            }
          } },
        { field: 'cay_no', title: '企业编码', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_type', title: '企业类型', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '0') {
              return `<span class='cell-edit-color'>商业公司</span>`
            } else if (rowData[field] === '1') {
              return `<span class='cell-edit-color'>服务商</span>`
            } else if (rowData[field] === '2') {
              return `<span class='cell-edit-color'>药品生产企业</span>`
            }
          } },
        { field: 'cay_nature', title: '企业性质', width: 130, isResize: true, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '0') {
              return `<span class='cell-edit-color'>企业</span>`
            } else if (rowData[field] === '1') {
              return `<span class='cell-edit-color'>个体工商户</span>`
            } else if (rowData[field] === '2') {
              return `<span class='cell-edit-color'>政府机关/事业单位</span>`
            }
          } },
        { field: 't_agent_info_agent_name', title: '渠道', width: 95, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'cay_name', title: '企业名称', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'certificateUrl', title: '天威授权书', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left', componentName: 'certificateUrl' },
        { field: 'signatureUrl', title: '签章', width: 100, isResize: true, titleAlign: 'left', columnAlign: 'left', componentName: 'signatureUrl' },
        { field: 'uk_no', title: '证书编码', width: 400, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } }
      ],
      industryCol: [ // 信息认证审核
        { field: 'operation', title: '操作', width: 120, titleAlign: 'left', columnAlign: 'left', componentName: 'operateVerify' },
        { field: 'cay_comfirm_state', title: '状态', width: 60, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '0') {
              return `<span class='cell-edit-color'>待审核</span>`
            } else if (rowData[field] === '1') {
              return `<span class='cell-edit-color'>待审核</span>`
            }
          } },
        { field: 'cay_create_time', title: '提交时间', width: 150, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_no', title: '企业编码', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_type', title: '企业类型', width: 100, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '0') {
              return `<span class='cell-edit-color'>商业公司</span>`
            } else if (rowData[field] === '1') {
              return `<span class='cell-edit-color'>服务商</span>`
            } else if (rowData[field] === '2') {
              return `<span class='cell-edit-color'>药品生产企业</span>`
            }
          } },
        { field: 'cay_nature', title: '企业性质', width: 130, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '0') {
              return `<span class='cell-edit-color'>企业</span>`
            } else if (rowData[field] === '1') {
              return `<span class='cell-edit-color'>个体工商户</span>`
            } else if (rowData[field] === '2') {
              return `<span class='cell-edit-color'>政府机关/事业单位</span>`
            }
          } },
        { field: 't_agent_info_agent_name', title: '渠道', width: 95, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'cay_name', title: '企业名称', width: 220, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'cay_tel', title: '联系电话', width: 110, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_social_credit_code', title: '统一社会信用代码', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_license', title: '营业执照注册号', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_tax_registration', title: '税务登记号', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_organization_code', title: '组织机构代码证', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'establish_date', title: '成立日期', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'business_term', title: '营业期限', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'business_scope', title: '经营范围', width: 180, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'cay_corp_name', title: '姓名', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_passport_no', title: '护照', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_corp_idcard', title: '身份证号', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_certigier_name', title: '姓名', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_certigier_idcard', title: '身份证号', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_cell_phone', title: '手机', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_adm_email', title: '电子邮箱', width: 180, titleAlign: 'left', columnAlign: 'left' }
      ],
      serverCol: [ // 信息认证审核
        { field: 'operation', title: '操作', width: 120, titleAlign: 'left', columnAlign: 'left', componentName: 'operateVerify' },
        { field: 'cay_comfirm_state', title: '状态', width: 60, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '0') {
              return `<span class='cell-edit-color'>待审核</span>`
            } else if (rowData[field] === '1') {
              return `<span class='cell-edit-color'>待审核</span>`
            }
          } },
        { field: 'cay_create_time', title: '提交时间', width: 150, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_no', title: '企业编码', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_type', title: '企业类型', width: 100, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '0') {
              return `<span class='cell-edit-color'>商业公司</span>`
            } else if (rowData[field] === '1') {
              return `<span class='cell-edit-color'>服务商</span>`
            } else if (rowData[field] === '2') {
              return `<span class='cell-edit-color'>药品生产企业</span>`
            }
          } },
        { field: 'cay_nature', title: '企业性质', width: 130, titleAlign: 'left', columnAlign: 'left',
          formatter: function(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '0') {
              return `<span class='cell-edit-color'>企业</span>`
            } else if (rowData[field] === '1') {
              return `<span class='cell-edit-color'>个体工商户</span>`
            } else if (rowData[field] === '2') {
              return `<span class='cell-edit-color'>政府机关/事业单位</span>`
            }
          } },
        { field: 't_agent_info_agent_name', title: '渠道', width: 95, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'cay_name', title: '企业名称', width: 220, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'cay_tel', title: '联系电话', width: 110, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_social_credit_code', title: '统一社会信用代码', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_license', title: '营业执照注册号', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_tax_registration', title: '税务登记号', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_organization_code', title: '组织机构代码证', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'business_category', title: '经营类目', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'establish_date', title: '成立日期', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'business_term', title: '营业期限', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'business_scope', title: '经营范围', width: 180, titleAlign: 'left', columnAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'cay_corp_name', title: '姓名', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_passport_no', title: '护照', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_corp_idcard', title: '身份证号', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_certigier_name', title: '姓名', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_certigier_idcard', title: '身份证号', width: 180, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_cell_phone', title: '手机', width: 100, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cay_adm_email', title: '电子邮箱', width: 180, titleAlign: 'left', columnAlign: 'left' }
      ],
      industryTitleRows: [
        [
          { fields: ['operation', 'cay_comfirm_state', 'cay_create_time', 't_agent_info_agent_name', 'cay_no', 'cay_type', 'cay_nature', 'cay_name', 'cay_tel', 'cay_social_credit_code', 'cay_license', 'cay_tax_registration', 'cay_organization_code', 'establish_date', 'business_term', 'business_scope'], title: '企业基本信息', titleAlign: 'center', colspan: 16 },
          { fields: ['cay_corp_name', 'cay_passport_no', 'cay_corp_idcard'], title: '法定代表人或授权代表人信息', titleAlign: 'center', colspan: 3 },
          { fields: ['cay_certigier_name', 'cay_certigier_idcard', 'cay_cell_phone', 'cay_adm_email'], title: '授权管理员信息', titleAlign: 'center', colspan: 4 }
        ],
        [
          { fields: ['operation'], title: '操作', titleAlign: 'left' },
          { fields: ['cay_comfirm_state'], title: '状态', titleAlign: 'left' },
          { fields: ['cay_create_time'], title: '提交时间', titleAlign: 'left' },
          { fields: ['cay_no'], title: '企业编码', titleAlign: 'left' },
          { fields: ['cay_type'], title: '企业类型', titleAlign: 'left' },
          { fields: ['cay_nature'], title: '企业性质', titleAlign: 'left' },
          { fields: ['t_agent_info_agent_name'], title: '渠道', titleAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
            return formatTitle(rowData[field])
          } },
          { fields: ['cay_name'], title: '企业名称', titleAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
            return formatTitle(rowData[field])
          } },
          { fields: ['cay_tel'], title: '联系电话', titleAlign: 'left' },
          { fields: ['cay_social_credit_code'], title: '统一社会信用代码', titleAlign: 'left' },
          { fields: ['cay_license'], title: '营业执照注册号', titleAlign: 'left' },
          { fields: ['cay_tax_registration'], title: '税务登记号', titleAlign: 'left' },
          { fields: ['cay_organization_code'], title: '组织机构代码证', titleAlign: 'left' },
          { fields: ['establish_date'], title: '成立日期', titleAlign: 'left' },
          { fields: ['business_term'], title: '营业期限', titleAlign: 'left' },
          { fields: ['business_scope'], title: '经营范围', titleAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
            return formatTitle(rowData[field])
          } },
          { fields: ['cay_corp_name'], title: '姓名', titleAlign: 'left' },
          { fields: ['cay_passport_no'], title: '护照', titleAlign: 'left' },
          { fields: ['cay_corp_idcard'], title: '身份证号', titleAlign: 'left' },
          { fields: ['cay_certigier_name'], title: '姓名', titleAlign: 'left' },
          { fields: ['cay_certigier_idcard'], title: '身份证号', titleAlign: 'left' },
          { fields: ['cay_cell_phone'], title: '手机', titleAlign: 'left' },
          { fields: ['cay_adm_email'], title: '电子邮箱', titleAlign: 'left' }
        ]
      ],
      serverTitleRows: [
        [
          { fields: ['operation', 'cay_comfirm_state', 'cay_create_time', 't_agent_info_agent_name', 'cay_no', 'cay_type', 'cay_nature', 'cay_name', 'cay_tel', 'cay_social_credit_code', 'cay_license', 'cay_tax_registration', 'cay_organization_code', 'business_category', 'establish_date', 'business_term', 'business_scope'], title: '企业基本信息', titleAlign: 'center', colspan: 17 },
          { fields: ['cay_corp_name', 'cay_passport_no', 'cay_corp_idcard'], title: '法定代表人或授权代表人信息', titleAlign: 'center', colspan: 3 },
          { fields: ['cay_certigier_name', 'cay_certigier_idcard', 'cay_cell_phone', 'cay_adm_email'], title: '授权管理员信息', titleAlign: 'center', colspan: 4 }
        ],
        [
          { fields: ['operation'], title: '操作', titleAlign: 'left' },
          { fields: ['cay_comfirm_state'], title: '状态', titleAlign: 'left' },
          { fields: ['cay_create_time'], title: '提交时间', titleAlign: 'left' },
          { fields: ['cay_no'], title: '企业编码', titleAlign: 'left' },
          { fields: ['cay_type'], title: '企业类型', titleAlign: 'left' },
          { fields: ['cay_nature'], title: '企业性质', titleAlign: 'left' },
          { fields: ['t_agent_info_agent_name'], title: '渠道', titleAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
            return formatTitle(rowData[field])
          } },
          { fields: ['cay_name'], title: '企业名称', titleAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
            return formatTitle(rowData[field])
          } },
          { fields: ['cay_tel'], title: '联系电话', titleAlign: 'left' },
          { fields: ['cay_social_credit_code'], title: '统一社会信用代码', titleAlign: 'left' },
          { fields: ['cay_license'], title: '营业执照注册号', titleAlign: 'left' },
          { fields: ['cay_tax_registration'], title: '税务登记号', titleAlign: 'left' },
          { fields: ['cay_organization_code'], title: '组织机构代码证', titleAlign: 'left' },
          { fields: ['business_category'], title: '经营类目', titleAlign: 'left' },
          { fields: ['establish_date'], title: '成立日期', titleAlign: 'left' },
          { fields: ['business_term'], title: '营业期限', titleAlign: 'left' },
          { fields: ['business_scope'], title: '经营范围', titleAlign: 'left', formatter(rowData, rowIndex, pagingIndex, field) {
            return formatTitle(rowData[field])
          } },
          { fields: ['cay_corp_name'], title: '姓名', titleAlign: 'left' },
          { fields: ['cay_passport_no'], title: '护照', titleAlign: 'left' },
          { fields: ['cay_corp_idcard'], title: '身份证号', titleAlign: 'left' },
          { fields: ['cay_certigier_name'], title: '姓名', titleAlign: 'left' },
          { fields: ['cay_certigier_idcard'], title: '身份证号', titleAlign: 'left' },
          { fields: ['cay_cell_phone'], title: '手机', titleAlign: 'left' },
          { fields: ['cay_adm_email'], title: '电子邮箱', titleAlign: 'left' }
        ]
      ]
    }
  }
}
